import { SUGGESTION_TYPES } from '../../models/Suggestion';

class SuggestionSerializer {
  static deSeralizeType(type) {
    switch (type) {
      case 1:
        return SUGGESTION_TYPES.PRODUCT;
      case 2:
        return SUGGESTION_TYPES.PRODUCT_TYPE;
      case 3:
        return SUGGESTION_TYPES.SUB_MENU;
      case 4:
        return SUGGESTION_TYPES.SPECIFIC_PRODUCT;
      default:
        return SUGGESTION_TYPES.SUB_MENU;
    }
  }

  static deSerialize(data) {
    return {
      type: SuggestionSerializer.deSeralizeType(data.Tipo),
      text: data.Nombre,
      id: String(data.Id),
    };
  }
}

export { SuggestionSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/SuggestionSerializer.js